<div *ngIf="global_texts" class="footer">
<!--  <img class="logo-footer" [src]="global_texts.logo_LR_src">-->

  <ul *ngIf="menu"
      class="list-unstyled footer_links d-flex flex-column flex-lg-row align-items-center justify-content-center gap-3">
    <li *ngFor="let item of menu">
      <!--<a role="button" [routerLink]="item.path" [innerHtml]="item.label"></a>-->
      <a role="button" (click)="goToPathOrLinkExterne(item.path)" [innerHtml]="item.label"></a>
    </li>
  </ul>

  <p class="small">
    <span class="fst-italic" [innerHtml]="global_texts.footer.text_pre_info + ' '"></span>
    <span [innerHtml]="global_texts.footer.text_info"></span>
  </p>

  <div class="copyright">
    <!--    @<span [innerHtml]="year + ' '"></span>-->
    <!--    <span [innerHtml]="global_texts.copyright"></span>-->
    <span [innerHtml]="code_footer"></span>
  </div>
</div>


